export default __webpack_public_path__ + "static/media/google-drive.ce8e9c8a.svg";